import { render } from "./purchases_admin.vue?vue&type=template&id=1ceaa17d"
import script from "./purchases_admin.vue?vue&type=script&lang=js"
export * from "./purchases_admin.vue?vue&type=script&lang=js"

import "./purchases_admin.vue?vue&type=style&index=0&id=1ceaa17d&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__